import { Message } from "element-ui";
import axios from "axios";
import { getToken } from "./auth";

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 对应国际化资源文件后缀
axios.defaults.headers["Content-Language"] = "zh_CN";
// 携带cookie
axios.defaults.withCredentials = true;

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: "",
  // 超时
  timeout: 180000
});

// request拦截器
service.interceptors.request.use(
  config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    if (getToken() && !isToken) {
      config.headers["Authorization"] = "accessToken=" + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers["Access-Control-Allow-Origin"] = "*";

    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?";
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              if (value[key] !== null && typeof value[key] !== "undefined") {
                let params = propName + "[" + key + "]";
                let subPart = encodeURIComponent(params) + "=";
                url += subPart + encodeURIComponent(value[key]) + "&";
              }
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }

    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  res => {
    console.log(res);
    // 未设置状态码则默认成功状态
    const status = res.status || 200;
    if (status !== 200) {
      Message({
        message: "请求错误: " + status,
        type: "error"
      });
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject("error");
    }
    // if (res.data.hasActionMessages || res.data.hasErrors)
    if (res.data.hasErrors) {
      console.log(res.data);
      if (res.data.actionErrors !== undefined) {
        Message({
          message: "请求错误: " + res.data.actionErrors,
          type: "error"
        });
      }
      // if (res.data.actionMessages !== undefined) {
      //   Message({
      //     message: '请求错误: ' + res.data.actionMessages,
      //     type: 'error'
      //   })
      // }
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject("error");
    }
    return res.data;
  },
  error => {
    console.log("请求错误: " + error);
    if (error.response.status === 401) {
      window.location.href = "/#/Login";
    } else {
      Message({
        message: "请求错误: " + error,
        type: "error"
      });
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js